export default defineNuxtRouteMiddleware(async (to) => {
  if (to.meta.public || import.meta.prerender)
    return

  // 简化健康检查，不再依赖后端 API
  // 如果需要可以异步检查，不阻塞路由
  const healthStore = useHealthStore()
  
  // 在后台静默检查，不阻塞页面加载
  healthStore.fetchHealthCheck().catch(() => {
    // 在控制台记录错误，但不阻塞用户操作
    console.warn('Health check failed, but continuing with frontend-only mode')
  })
})
